module.exports = __webpack_public_path__ + "static/media/transparentCheck.9d5b2510.png";